export enum BrandingFooter {
    ContactLink = 'contactLink',
    FooterLinks = 'footerLinks'
}

export enum BrandingHeader {
    Banner = 'banner',
    TopBar = 'topBar',
    BannerOffset = 'bannerOffset'
}



// WEBPACK FOOTER //
// ./src/models/branding.ts